import React from 'react'

import RequestForm from "../model/request-form"
import FormViewHeader from "./form-header/form-header"
import FromViewBody from "./form-body/form-body"
import FormManager from "../../../../core/gd-form/common/form-manager"
import getFormBackgroundStyle from "../functions/get-form-background-style"
import prepareFormDataForSubmission from "../functions/prepare-for-submission"
import createFormViewFormManager from "../functions/craete-form-manager"
import GDManagerNewTask from "../../../../core/gd/manager/new-task-manager"
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import prepareFormDataForSharedViewSubmission from "../functions/prepare-for-shared-view-submission"

type Props = {
    publicKey?  : string
    requestForm : RequestForm
    header?     : any

    onSubmit?   : {():void}
}


// const debug = "FormView"
const debug = false

export default class RequestForm_FormView extends React.Component<Props> {

    private form: FormManager

    constructor(props:Props) {
        super(props)

        this.form = createFormViewFormManager(props.requestForm, this.onSubmit)
    }

    onSubmit = async (result:any) => {

        debug && console.log(debug, "onSubmit() result=", result)

        let submissionData
        switch (gd.viewMode) {
            case 'shared-view'  :
                submissionData = prepareFormDataForSharedViewSubmission(this.props.requestForm, result)
                debug && console.log(debug, 'onSubmit', result, submissionData, this.props.requestForm)
                await gd.api.SharedView.submitData(this.props.publicKey, 'submit-form', submissionData).promise()
                break

            default:
                submissionData = prepareFormDataForSubmission(this.props.requestForm, result)
                debug && console.log(debug, 'onSubmit', result, submissionData, this.props.requestForm)
                debug && console.log("    ", 'result=', result)
                debug && console.log("    ", 'submissionData=', submissionData)
                debug && console.log("    ", 'requestForm=', this.props.requestForm)
                await GDManagerNewTask.newTask(
                    gd.companyId, this.props.requestForm.projectId, this.props.requestForm.taskTypeId, submissionData.title, submissionData
                ).promise()
        }

        this.form.reset()

        this.props.onSubmit && this.props.onSubmit()
    }

    render() {
        return (
            <VScroll containerClass             = "form-container"
                     containerStyle             = {getFormBackgroundStyle(this.props.requestForm)}
                     minDragHeight              = {10}
                     mutationObserverEnabled    = {true}>

                {this.props.header}

                <div className="form">
                    <FormViewHeader requestForm={this.props.requestForm}/>
                    <FromViewBody requestForm   = {this.props.requestForm}
                                  form          = {this.form}/>
                </div>
            </VScroll>
        )
    }
}